import { Flex } from "@chakra-ui/layout";
import { Image, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import TagStatus from "./components/TagStatus";
import { AnuncioDto, AnuncioStatusEnum } from "features/anuncio/typings";

function useAnunciosColumns() {
  return useMemo(() => {
    return [
      {
        title: () => <Flex minW="80px" />,
        width: "100px",
        render: (original: AnuncioDto) =>
          original.imagemUrl ? (
            <Image
              src={original.imagemUrl}
              w="100%"
              h="80px"
              objectFit="cover"
              borderRadius="md"
            />
          ) : (
            <Text>Sem imagem</Text>
          ),
      },
      {
        title: "Nome do anúncio",
        width: "250px",
        render: (original: AnuncioDto) => <Flex>{original.nome}</Flex>,
      },
      {
        title: "Anunciante",

        render: (original: AnuncioDto) => <Flex>{original.pessoa.nome}</Flex>,
      },
      {
        title: "Tipo de anúncio",

        render: (original: AnuncioDto) => (
          <Flex>{original.tipoAnuncio.nome}</Flex>
        ),
      },
      {
        title: "Status",
        width: "200px",
        render: (original: AnuncioDto) => (
          <Flex>
            {original.status.id === AnuncioStatusEnum.Aprovado ? (
              <TagStatus color="green" status="Aprovado" />
            ) : original.status.id === AnuncioStatusEnum.EmAnalise ? (
              <TagStatus color="orange" status="Em análise" />
            ) : original.status.id === AnuncioStatusEnum.Rejeitado ? (
              <TagStatus color="white" status="Rejeitado" bg="red" />
            ) : (
              <TagStatus color="orange" status="Pendente" />
            )}
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useAnunciosColumns;
